module.exports = __webpack_public_path__ + "assets/img/icon3.effe1472.png";